





















































































































































































































































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { EPLModule } from '../store/eplmodule'
import moment from 'moment'

@Component({
  name: 'UIField',
  components: {
    DateTimePicker: () =>
      import(
        /* webpackChunkName: "DateTimePicker" */ '@/components/DateTimePicker.vue'
      ),
    RouteBuilder: () =>
      import(
        /* webpackChunkName: "RouteBuilder" */ '@/components/RouteBuilder.vue'
      ),
    CRUD: () =>
      import(
        /* webpackChunkName: "CRUD" */ '@/components/CRUD.vue'
      ),
    ActionFields: () =>
      import(
        /* webpackChunkName: "ActionFields" */ '@/components/ActionFields.vue'
      )
  }
})
export default class UIField extends Vue {
  @Prop() type!: string
  @Prop() icon!: string
  @Prop() label!: string
  @Prop() model!: string | number | boolean
  @Prop() items!: []
  @Prop() len!: number
  @Prop() required!: boolean
  @Prop() readonly!: boolean
  @Prop() disabled!: boolean
  @Prop() signed!: boolean
  @Prop() calculate!: string
  @Prop() field!: string

  bigtime = false

  buttonLoading = false

  @Emit('updateMultipleselect')
  updateMultipleselect () { /* */ }

  @Emit('update:model')
  update (val: string | number | boolean) { return val }

  get value () {
    if (this.calculate !== undefined) {
      const d = this.calculate.split(',')
      const idx = EPLModule.DictIdx(d[0])
      let res = 0
      let orig = 0
      let orig2 = 0
      let orig3 = 0
      EPLModule.dicts[idx].rows.forEach(r => {
        if (r.id === EPLModule.dicts[idx].currentRow.id) {
          orig = r[this.field]
          orig2 = r[d[2]]
          orig3 = r[d[3]]
        }
      })
      if (d[1] === 'diff') {
        if (parseFloat((orig2 - orig3).toFixed(2)) === orig || orig === 0) {
          res = parseFloat((EPLModule.dicts[idx].currentRow[d[2]] - EPLModule.dicts[idx].currentRow[d[3]]).toFixed(2))
          if (res < 0) res = 0
        } else {
          res = orig
        }
        this.update(res)
        return res
      }
      if (d[1] === 'summ') {
        if (parseFloat((orig2 + orig3).toFixed(2)) === orig || orig === 0) {
          res = parseFloat((EPLModule.dicts[idx].currentRow[d[2]] + EPLModule.dicts[idx].currentRow[d[3]]).toFixed(2))
        } else {
          res = orig
        }
        this.update(res)
        return res
      }
      if (d[1] === 'div') {
        if (orig2 / parseFloat(d[3]) === orig || orig === 0) {
          res = parseFloat((EPLModule.dicts[idx].currentRow[d[2]] / parseFloat(d[3])).toFixed(2))
        } else {
          res = orig
        }
        this.update(res)
        return res
      }
      if (d[1] === 'hours') {
        const arrived = EPLModule.dicts[idx].currentRow[d[3]] === 0 ? EPLModule.dicts[idx].currentRow.arrivedtime : EPLModule.dicts[idx].currentRow[d[3]]
        const depart = EPLModule.dicts[idx].currentRow[d[2]]
        res = Math.round((depart - arrived) / 60)
        const idxEPL = EPLModule.DictIdx('EPL')
        const dbeg = EPLModule.dicts[idxEPL].currentRow.dinnerbegin
        const dend = EPLModule.dicts[idxEPL].currentRow.dinnerend
        let dinner = 0
        // обед полностью попал в СЗ
        if (arrived <= dbeg && depart >= dend) dinner = dend - dbeg
        // обед закончился в СЗ
        else if (arrived >= dbeg && depart >= dend) dinner = dend - arrived
        // обед начался в СЗ
        else if (arrived <= dbeg && depart <= dend) dinner = depart - dbeg
        if (dinner > 0) res -= Math.ceil(dinner / 60)
        const sec = Math.round(res)
        const h = Math.trunc(sec / 60)
        const m = sec - h * 60
        let ht = `${h}`
        if (h < 10) ht = '0' + h
        let mt = `${m}`
        if (m < 10) mt = '0' + m
        this.bigtime = (h > 23)
        this.update(sec)
        return `${ht}:${mt}`
      }
    }
    if (this.type === 'time') {
      const sec = this.model as number
      const h = Math.trunc(sec / 60)
      const m = sec - h * 60
      let ht = `${h}`
      if (h < 10) ht = '0' + h
      let mt = `${m}`
      if (m < 10) mt = '0' + m
      this.bigtime = (h > 23)
      return `${ht}:${mt}`
    }
    return this.model
  }

  set value (val) {
    if (this.type === 'time') {
      const time = `${val}`
      const tm = time.split(':')
      const h = parseInt(tm[0])
      const m = parseInt(tm[1])
      const sec = h * 60 + m
      this.update(sec)
      return
    }
    // if (typeof this.model === 'number') {
    //   const v = val as string
    //   val = parseInt(v)
    // }
    if (this.type === 'number') {
      const v = val as string
      val = parseInt(v)
    }
    if (this.type === 'float') {
      const v = val as string
      val = parseFloat(v)
    }
    if (this.type === 'atselect') {
      // костыль для обновления списка полей справочника для AccessTable
      EPLModule.fetchHeadersList(val as string)
        .then(() => { this.updateMultipleselect() })
    }
    this.update(val)
  }

  checkDot (e: KeyboardEvent) {
    if (e.key === '.') {
      // игнорировать нажатие !!!
      e.preventDefault()
    }
  }

  onChange () {
    if (this.calculate !== undefined) {
      const d = this.calculate.split(',')
      const idx = EPLModule.DictIdx(d[0])
      if (d[1] === 'change') {
        if (d[3] === 'true') {
          EPLModule.dicts[idx].currentRow[d[2]] = true
        } else if (d[3] === 'false') {
          EPLModule.dicts[idx].currentRow[d[2]] = false
        } else {
          EPLModule.dicts[idx].currentRow[d[2]] = d[3]
        }
      }
    }
  }

  private async buttonClick (required: string, len: string, id: string | number) {
    this.buttonLoading = true
    if (len === 'epltogalaxy') {
      const idx = EPLModule.DictIdx('EPL')
      EPLModule.eplToGalaxy(EPLModule.dicts[idx].currentRow.id)
        .then((response: any) => {
          EPLModule.dicts[idx].currentRow.galaxysync = response.data.reqtime
          this.buttonLoading = false
        })
        .catch(() => {
          this.buttonLoading = false
        })
    }
    if (len === 'dinner') {
      const idx = EPLModule.DictIdx('EPL')
      EPLModule.dicts[idx].currentRow.dinnerbegin = Math.floor(moment().unix() / 60) * 60
      EPLModule.dicts[idx].currentRow.dinnerend = EPLModule.dicts[idx].currentRow.dinnerbegin + EPLModule.dicts[idx].currentRow.dinnertime * 60
      this.buttonLoading = false
    }
    if (len === 'glonass') {
      const eplid = id as number
      const idx = EPLModule.DictIdx('EPL')
      EPLModule.getAskData({ id: eplid, type: len, p1: EPLModule.dicts[idx].currentRow.departurefacttime, p2: EPLModule.dicts[idx].currentRow.arrivedfacttime })
        .then((response: any) => {
          const fields = required.split(',')
          fields.forEach((f: any) => {
            EPLModule.dicts[idx].currentRow[f] = response.data[f]
          })
          this.buttonLoading = false
        }).catch(() => { this.buttonLoading = false })
    }
    if (len === 'glonasstask') {
      const idx = EPLModule.DictIdx('DriverTasks')
      const idxEPL = EPLModule.DictIdx('EPL')
      const eplid = EPLModule.dicts[idxEPL].currentRow.id
      EPLModule.getAskData({ id: eplid, type: len, p1: EPLModule.dicts[idx].currentRow.clientarrivedtime, p2: EPLModule.dicts[idx].currentRow.clientdeparturetime })
        .then((response: any) => {
          const fields = required.split(',')
          fields.forEach((f: any) => {
            EPLModule.dicts[idx].currentRow[f] = response.data[f]
          })
          EPLModule.dicts[idx].currentRow.departuremileage = EPLModule.dicts[idx].currentRow.arrivedmileage + EPLModule.dicts[idx].currentRow.worktimemileage
          this.buttonLoading = false
        }).catch(() => { this.buttonLoading = false })
    }
    if (len === 'driverjob') {
      const fields = required.split(',')
      const idx = EPLModule.DictIdx('DriverTasks')
      const idxEPL = EPLModule.DictIdx('EPL')
      // установка текущего времени водителю
      EPLModule.dicts[idx].currentRow[fields[0]] = true
      EPLModule.dicts[idx].currentRow[fields[1]] = moment().unix()
      if (fields[0] === 'start') {
        // поиск предыдущего задания
        let maxtime = 0
        let maxid = -1
        EPLModule.dicts[idx].rows.forEach((r, i) => {
          if (r.arrivedtime > maxtime && r.arrivedtime < EPLModule.dicts[idx].currentRow.arrivedtime) {
            maxid = i
            maxtime = r.arrivedtime
          }
        })
        if (maxid === -1) {
          // это первое задание, ставим время по факту ЭПЛ заказчику
          EPLModule.dicts[idx].currentRow.clientarrivedtime = EPLModule.dicts[idxEPL].currentRow.departurefacttime
          // а так же пробег из ЭПЛ
          EPLModule.dicts[idx].currentRow.arrivedmileage = EPLModule.dicts[idxEPL].currentRow.departuretotalmileage
        } else {
          // предыдущее задание
          EPLModule.dicts[idx].currentRow.clientarrivedtime = EPLModule.dicts[idx].rows[maxid].driverdeparturetime
          EPLModule.dicts[idx].currentRow.arrivedmileage = EPLModule.dicts[idx].rows[maxid].departuremileage
        }
        EPLModule.saveDictCurrentRow({ idx: idx, hide: false })
      }
      if (fields[0] === 'done') {
        EPLModule.dicts[idx].currentRow.clientdeparturetime = EPLModule.dicts[idx].currentRow[fields[1]]
        EPLModule.saveDictCurrentRow({ idx: idx, hide: true })
      }
      if (fields[0] === 'togarage') {
        EPLModule.dicts[idx].currentRow.done = true
        // это последнее задание, ставим время по плану ЭПЛ заказчику
        EPLModule.dicts[idx].currentRow.clientdeparturetime = EPLModule.dicts[idxEPL].currentRow.arrivedfacttime
        EPLModule.saveDictCurrentRow({ idx: idx, hide: true })
      }
      this.buttonLoading = false
      // EPLModule.saveDictCurrentRow({ idx: idx, hide: true })
    }
  }

  private buttonDisable (required: string, len: string, id: string | number): boolean {
    if (len === 'epltogalaxy') {
      return false
    }
    if (len === 'dinner') {
      const idx = EPLModule.DictIdx('EPL')
      if (EPLModule.user.roleid !== 7 && EPLModule.user.roleid !== 1) return true
      if (EPLModule.dicts[idx].currentRow.dinnertime === 0) return true
      if (EPLModule.dicts[idx].currentRow.dinnerbegin !== EPLModule.dicts[idx].currentRow.dinnerend) return true
      return false
    }
    if (len === 'glonass') {
      return false
    }
    if (len === 'glonasstask') {
      const idx = EPLModule.DictIdx('DriverTasks')
      if (EPLModule.dicts[idx].currentRow.id === 0) return true
      return false
    }
    if (len === 'driverjob') {
      if (EPLModule.user.roleid !== 7 && EPLModule.user.roleid !== 1) return true
      const fields = required.split(',')
      const idx = EPLModule.DictIdx('DriverTasks')
      if (fields[0] === 'start') {
        if (EPLModule.dicts[idx].currentRow.id === 0) return true
        // поиск предыдущего задания
        let maxtime = 0
        let maxid = -1
        EPLModule.dicts[idx].rows.forEach((r, i) => {
          if (r.arrivedtime > maxtime && r.arrivedtime < EPLModule.dicts[idx].currentRow.arrivedtime) {
            maxid = i
            maxtime = r.arrivedtime
          }
        })
        // предыдущее задание
        if (maxid !== -1 && !EPLModule.dicts[idx].rows[maxid].done) return true
        return EPLModule.dicts[idx].currentRow.start
      }
      if (EPLModule.dicts[idx].currentRow.start) {
        if (fields[0] === 'done') {
          if (EPLModule.dicts[idx].currentRow.done) return true
          return false
          // // поиск последнего задания
          // let maxtime = 0
          // let maxid = 0
          // EPLModule.dicts[idx].rows.forEach((r, i) => {
          //   if (r.departuretime > maxtime) {
          //     maxid = i
          //     maxtime = r.departuretime
          //   }
          // })
          // // это последнее задание, нельзя нажать кнопку закончил работу
          // return (EPLModule.dicts[idx].rows[maxid].id === EPLModule.dicts[idx].currentRow.id)
        }
        if (fields[0] === 'togarage') {
          if (EPLModule.dicts[idx].currentRow.togarage) return true
          // поиск нажатой кнопки в гараж
          let res = false
          EPLModule.dicts[idx].rows.forEach((r) => {
            if (r.togarage) {
              res = true
            }
          })
          if (res) return true
          // поиск последующего начатого задания
          EPLModule.dicts[idx].rows.forEach((r) => {
            if (r.departuretime > EPLModule.dicts[idx].currentRow.departuretime) {
              if (r.start) {
                res = true
              }
            }
          })
          if (res) return true
          return false
        }
      } else return true
    }
    return true
  }
}
